import { render, staticRenderFns } from "./DownSq.vue?vue&type=template&id=7a07f722"
import script from "./DownSq.vue?vue&type=script&lang=ts"
export * from "./DownSq.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports